export default class SliderFlexible {
  constructor(view) {
    this.view = view;
    this.slider = this.view.querySelector(".swiper-container");
    this.sliderNext = this.view.querySelector(".swiper-button-next");
    this.sliderPrev = this.view.querySelector(".swiper-button-prev");
    this.sliderPagination = this.view.querySelector(".swiper-pagination");

    var slider = new Swiper(this.slider, {
      spaceBetween: 15,
      loop: false,
      navigation: {
        nextEl: this.sliderNext,
        prevEl: this.sliderPrev,
      },
      pagination: {
        el: this.sliderPagination,
        type: "fraction",
      },
    });

    this.resizeSlider();
    this.resizeSlider = this.resizeSlider.bind(this);
    window.addEventListener("resize", this.resizeSlider);
  }

  resizeSlider() {
    this.view.style.setProperty("--swiper-width", this.slider.offsetWidth + "px");
  }
}
